var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('i',{staticClass:"fas fa-question-circle",class:_vm.iconClasses,attrs:{"id":_vm.tooltipId}}),_c('b-tooltip',{class:_vm.tooltipClasses,attrs:{"target":_vm.tooltipId,"variant":_vm.variant,"placement":_vm.placement}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }